import {JourneyTrack} from '../journey-track';
import {TrackTypes} from '../model/track-types';
import {TrackInfo} from '../model/track-info';
import {TrackActionResult} from '../model/track-action-result';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';
import { trackIncomeUpdateContaIon } from '../cadastro-investidor-v2/util/track-default-income-v2';

export class UpdateIncomeContaIonTrack extends JourneyTrack {
  readonly originalTracks = [
    ...trackIncomeUpdateContaIon,
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.updateRegistration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {dataOrigin: DomainOrigin[environment.updateRegistration]})
  ];

  track = [];

  constructor() {
    super();
    this.track = this.originalTracks;
  }

  
  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.UPDATE_REGISTRATION;
  }

  async loadData(){
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    throw new Error('Method not implemented.');
  }
  isUncoupled() {
    return true;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
  
}
